import React, { useEffect } from "react";
import "./form.css";

const VendorsForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          region: "na1",
          portalId: "2867024",
          formId: "4037b7a3-26d3-4907-b40a-62f9f29ea4a7",
          target: "#hubspotForm",
          cssClass: "form",
        });
      }
    });
  }, []);

  return <div style={{ textAlign: "left" }} id="hubspotForm" />;
};

export default VendorsForm;
